import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IBrightcoveData, IBrightcoveState } from 'redux-state/brightcove/types.js';

const initialState: IBrightcoveState = {
  status: undefined,
  loading: false,
};

export const brightcoveSlice = createSlice({
  name: 'brightcove',
  initialState,
  reducers: {
    REDUX_BRIGHTCOVE_GET_STATUS_ASYNC: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    REDUX_BRIGHTCOVE_GET_STATUS_SUCCESS: (_, action: PayloadAction<{ status: Record<string, IBrightcoveData> }>) => {
      return {
        loading: false,
        status: action.payload.status,
      };
    },
    REDUX_BRIGHTCOVE_GET_STATUS_ERROR: (state) => {
      return {
        ...state,
        loading: undefined,
      };
    },
  },
});

export const {
  REDUX_BRIGHTCOVE_GET_STATUS_ASYNC,
  REDUX_BRIGHTCOVE_GET_STATUS_SUCCESS,
  REDUX_BRIGHTCOVE_GET_STATUS_ERROR,
} = brightcoveSlice.actions;

export const appReducer = brightcoveSlice.reducer;

// export const brightcoveReducer = (
//   state: IBrightcoveState = initialState,
//   action: BrightcoveActions,
// ): IBrightcoveState => {
//   switch (action.type) {
//     case TypeKeys.BRIGHTCOVE_GET_STATUS:
//       return {
//         ...state,
//         loading: true,
//       };
//     case TypeKeys.BRIGHTCOVE_GET_STATUS_SUCCESS:
//       return {
//         ...state,
//         ...action.payload.newState,
//         loading: false,
//       };
//     case TypeKeys.BRIGHTCOVE_GET_STATUS_ERROR:
//       console.warn(action.payload.error);
//       return {
//         ...state,
//         loading: undefined,
//       };
//     default:
//       return state;
//   }
// };
